// src/pages/Register.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

import "../styles/Login.css";

const Register = () => {
  const navigate = useNavigate();

  // Form states
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  // Helper to show modal reliably
  const showModalWithMessage = (message, success) => {
    setModalMessage(message);
    setIsSuccess(success);
    setShowModal(true);
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    // Reset modal state
    setShowModal(false);
    setIsSuccess(false);
    setModalMessage("");

    // Simple validation
    if (!fullName || !email || !password) {
      showModalWithMessage("All fields are required.", false);
      return;
    }

    if (password.length < 6) {
      showModalWithMessage("Password must be at least 6 characters.", false);
      return;
    }

    try {
      // 🔹 Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 🔹 Attempt Firestore write, but don't block success
      try {
        await setDoc(doc(db, "users", user.uid), {
          fullName,
          email,
          role: "tenant",
          createdAt: serverTimestamp(),
        });
      } catch (firestoreError) {
        console.warn("Firestore save failed:", firestoreError);
        // optional: log or send to monitoring
      }

      // ✅ Show success modal
      showModalWithMessage("Registration successful! You can now log in.", true);

    } catch (authError) {
      // Map Firebase Auth errors
      let message = "Something went wrong. Please try again.";
      if (authError.code === "auth/email-already-in-use") message = "This email is already registered.";
      else if (authError.code === "auth/invalid-email") message = "Invalid email address.";
      else if (authError.code === "auth/weak-password") message = "Password is too weak.";

      showModalWithMessage(message, false);
    }
  };

  const handleModalOk = () => {
    setShowModal(false);
    if (isSuccess) {
      navigate("/login");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h2 className="login-title">Create Account</h2>
        <p className="login-sub">Join Smart Hostel</p>

        <form className="login-form" onSubmit={handleRegister}>
          <div className="input-group">
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
            <label>Full Name</label>
          </div>

          <div className="input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label>Email</label>
          </div>

          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label>Password</label>
          </div>

          <button type="submit" className="login-btn">
            Register
          </button>
        </form>

        <p className="login-footer">
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            style={{ color: "#2563eb", cursor: "pointer" }}
          >
            Login
          </span>
        </p>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{isSuccess ? "Success" : "Error"}</h3>
            <p>{modalMessage}</p>
            <button className="modal-btn" onClick={handleModalOk}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;
